import { RedirectToDownload } from "/react4xp/parts/redirect-to-download/redirect-to-download";

export default (props) => <RedirectToDownload {...props} />